<template>
  <div class="shw">
    <div v-if="!chart" class="shw-note">Loading the chart…</div>
    <template v-else>
      <div class="shw-meta">
        <span>{{ chart.workflow }}<template v-if="asOf"> · {{ asOf }}</template></span>
        <span v-if="coverage" class="shw-coverage">{{ coverage }}</span>
        <span v-if="chart.totals && summary && summary.total !== null && chart.chart_type !== 'kpi'" class="shw-total">{{ summary.total_label }} <strong>{{ formatNumber(summary.total) }}</strong></span>
      </div>
      <div v-if="chart.chart_type === 'kpi'" class="shw-kpi">{{ formatNumber(summary ? summary.total : null) }}</div>
      <div v-else-if="view.component === 'chart_v6'" class="shw-chart sensitive" data-demo-blur :style="chartStyle">
        <Chart_V6 :spec="view.props.spec" />
      </div>
      <div v-else class="shw-table">
        <table>
          <thead><tr><th v-for="c in view.props.columnDefs" :key="c.field">{{ c.headerName || c.field }}</th></tr></thead>
          <tbody>
            <tr v-for="(r, i) in view.props.rowData" :key="i">
              <td v-for="c in view.props.columnDefs" :key="c.field" class="sensitive">{{ r[c.field] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import Chart_V6 from '@/components/widgetcomponents/Viz_Elements/Chart_V6.vue';
import { asOfText, coverageText, formatNumber, sheetViz } from '@/utils/sheetAnalytics';

export default {
  name: 'SheetWidget',
  components: { Chart_V6 },
  props: {
    inputs: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },
  computed: {
    input() {
      return this.inputs.rows || {};
    },
    chart() {
      return this.input.chart || null;
    },
    summary() {
      return this.chart.summary || null;
    },
    coverage() {
      return coverageText(this.summary);
    },
    asOf() {
      return asOfText(this.chart.as_of);
    },
    view() {
      return sheetViz({ ...this.chart, rows: this.input.rows || [] }, this.chart.reference, this.chart.color);
    },
    chartStyle() {
      const room = Math.max(140, (this.height || 320) - 48);
      const width = Math.min(Math.max((this.width || 640) - 24, 200), Math.round(room * 1.8));
      return { width: `${width}px` };
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped>
.shw { display: flex; flex-direction: column; gap: 4px; height: 100%; padding: 8px 12px; box-sizing: border-box; }
.shw-note { font-size: 12px; color: #626264; }
.shw-meta { display: flex; justify-content: space-between; gap: 8px; height: 20px; font-size: 11px; color: #626264; }
.shw-coverage { margin-left: auto; }
.shw-total strong { color: #1E1F21; }
.shw-kpi { font-size: 40px; font-weight: 600; color: #1E1F21; font-variant-numeric: tabular-nums; }
.shw-chart { margin: 0 auto; }
.shw-table { overflow: auto; }
.shw-table table { border-collapse: collapse; font-size: 12px; width: 100%; }
.shw-table th { background: #F4F4F4; text-align: left; font-weight: 600; color: #1E1F21; padding: 4px 8px; border-bottom: 1px solid #E8E9E9; }
.shw-table td { padding: 4px 8px; border-bottom: 1px solid #E8E9E9; color: #353537; }
</style>
